<template>
  <div class="left-card-wrap">
    <div class="header-title-wrap">
      <span class="title">总览</span>
    </div>
    <div class="total-card">
      <div class="text">专利总量<span class="count">/件数</span></div>
      <div class="total-num">{{ total }}</div>
      <ChangeCard name="同比增长" :value="`${totalGrowth}%`"></ChangeCard>
    </div>
    <div class="mid-total-wrap">
      <div class="apply-card-wrap">
        <div class="left-wrap">
          <div class="text">本年度新增专利申请/件数</div>
          <div class="apply-value">{{ appTotal }}</div>
          <ChangeCard name="同比增长" :value="`${appGrowth}%`"></ChangeCard>
        </div>
        <div class="right-wrap">
          <a-progress
            type="circle"
            :strokeWidth="10"
            :percent="appGrowth"
            :success-percent="40"
            :format="(percent) => isApplyNegative(percent)"
          />
        </div>
      </div>
      <div class="add-card-wrap">
        <div class="left-wrap">
          <div class="text">本年度新增专利授权/件数</div>
          <div class="apply-value">{{ authorTotal }}</div>
          <ChangeCard name="同比增长" :value="`${authorGrowth}%`"></ChangeCard>
        </div>
        <div class="right-wrap">
          <a-progress
            type="circle"
            :strokeWidth="10"
            :percent="authorGrowth"
            :success-percent="40"
            :format="(percent) => isAuthorNegative(percent)"
          />
        </div>
      </div>
    </div>
    <div class="progress-bar-wrap">
      <div class="progress-title-wrap">院系统计</div>
      <div
        class="progress-content-wrap"
        v-for="(item, index) in collageList"
        :key="item.id"
      >
        <div class="text-wrap">
          <div class="left-wrap">
            <div>
              <IconWrap
                :width="15"
                :height="15"
                :url="`/static/patentAtlas/${index + 1}.png`"
              ></IconWrap>
            </div>
            <span>{{ item.ORG }}</span>
          </div>
          <div class="right-wrap">
            <span class="num">{{ item.total }}件</span>
            <span class="increase-text">
              <span>{{ item.rant }}%</span>
              <IconWrap
                :width="9"
                :height="15"
                url="/static/patentAtlas/row.png"
              ></IconWrap>
            </span>
          </div>
        </div>
        <a-progress
          :stroke-color="{ from: '#0167E6', to: '#FFFFFF' }"
          :percent="item.ratio"
          :height="20"
          :showInfo="false"
        />
      </div>
    </div>
    <div class="progress-bar-wrap">
      <div class="progress-title-wrap">发明人统计</div>
      <div
        class="progress-content-wrap"
        v-for="(item, index) in inventorList"
        :key="item.id"
      >
        <div class="text-wrap">
          <div class="left-wrap">
            <div>
              <IconWrap
                :width="15"
                :height="15"
                :url="`/static/patentAtlas/${index + 1}.png`"
              ></IconWrap>
            </div>
            <span>{{ item.INVENTOR }}</span>
          </div>
          <div class="right-wrap">
            <span class="num">{{ item.total }}件</span>
            <span class="increase-text">
              <span>{{ item.rant }}%</span>
              <IconWrap
                :width="9"
                :height="15"
                url="/static/patentAtlas/row.png"
              ></IconWrap>
            </span>
          </div>
        </div>
        <a-progress
          :stroke-color="{ from: '#0167E6', to: '#FFFFFF' }"
          :percent="item.ratio"
          :height="20"
          :showInfo="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
const TEMPLATEID = process.env.VUE_APP_BASE_TEMPLATEID;
import ChangeCard from "./ChangeCard.vue";
import { getchartData, getGrowthData } from "@/api/databaseBin";
import dayjs from "dayjs";
const currentTime = dayjs().format("YYYY-MM-DD");
const currentYear = dayjs().format("YYYY");
export default {
  props: {
    date: String,
  },
  data() {
    return {
      collageList: [],
      inventorList: [],
      inventorParams: {
        firstDim: "INVENTOR",
        measureFields: ["application_num"],
        querys: [
          {
            property: "PUBLICATION_YEAR",
            operation: "BETWEEN",
            value: `1986,${currentYear}`,
          },
          {
            operation: "IN",
            property: "PATENT_TYPE",
            value: "invent,newKind,exterior",
          },
          {
            operation: "LESS_EQUAL",
            property: "INVENTOR",
            value: "10",
          },
        ],
        secondDim: "",
        viewName: "PATENT_COUNT_ANALYSIS",
      },
      collageParams: {
        firstDim: "ORG",
        measureFields: ["application_num"],
        querys: [
          {
            property: "PUBLICATION_YEAR",
            operation: "BETWEEN",
            value: `1986,${currentYear}`,
          },
          {
            operation: "IN",
            property: "PATENT_TYPE",
            value: "invent,newKind,exterior",
          },
          {
            operation: "LESS_EQUAL",
            property: "ORG",
            value: "3",
          },
        ],
        secondDim: "PUBLICATION_YEAR",
        viewName: "PATENT_COUNT_ANALYSIS",
      },
      total: 0,
      preTotal: 0,
      preGrowth: [],
      totalGrowth: 0,
      appTotal: 0,
      appGrowth: 0,
      authorTotal: 0,
      authorGrowth: 0,
      showApplyNegative: false,
      showAuthorNegative: false,
    };
  },
  watch: {
    date: {
      handler(nval) {
        const chartArr = nval.split("-");
        const chart = parseInt(chartArr[0]) - 1;
        chartArr[0] = chart;
        const preDate = chartArr.join("-");
        this.preGrowth = ["1986-01-01", preDate];
      },
      immediate: true,
    },
  },
  created() {
    this.initSetting();
  },
  components: {
    ChangeCard,
  },
  methods: {
    async initSetting() {
      this.initTotal();
      this.newPatentApp();
      this.newPatentAuthorize();
      this.initInventor();
      this.initCollage();
    },
    async initTotal() {
      const curGrowthParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_PUBLICATION_DATE",
              relation: "AND",
              value: ["1986-01-01", this.date],
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const { total } = await getGrowthData(curGrowthParams);
      this.total = total;
      const growthParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_PUBLICATION_DATE",
              relation: "AND",
              value: this.preGrowth,
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const { total: preGrowth } = await getGrowthData(growthParams);
      this.preTotal = preGrowth;
      this.totalGrowth = (((total - preGrowth) / preGrowth) * 100).toFixed(1);
    },
    async initInventor() {
      const { value } = await getchartData(this.inventorParams);
      value.forEach(async (item) => {
        item.total = item.application_num;
        const preParams = {
          queryFilter: {
            pageBean: {
              page: 1,
              pageSize: 20,
            },
            querys: [
              {
                group: "main",
                operation: "LIKE",
                property: "F_INVENTOR",
                relation: "AND",
                value: item.INVENTOR,
              },
              {
                group: "main",
                operation: "BETWEEN",
                property: "F_PUBLICATION_DATE",
                relation: "AND",
                value: this.preGrowth,
              },
            ],
          },
          templateId: TEMPLATEID,
        };

        const curParams = {
          queryFilter: {
            pageBean: {
              page: 1,
              pageSize: 20,
            },
            querys: [
              {
                group: "main",
                operation: "LIKE",
                property: "F_INVENTOR",
                relation: "AND",
                value: item.INVENTOR,
              },
              {
                group: "main",
                operation: "BETWEEN",
                property: "F_PUBLICATION_DATE",
                relation: "AND",
                value: ["1986-01-01", this.date],
              },
            ],
          },
          templateId: TEMPLATEID,
        };
        Promise.all([getGrowthData(preParams), getGrowthData(curParams)]).then(
          (res) => {
            const preTotal = res[0].total;
            const total = res[1].total;
            const rant = (((total - preTotal) / preTotal) * 100).toFixed(1);
            this.$set(item, "rant", rant);
          }
        );
        // const { total: preTotal } = await getGrowthData(preParams)
        // const { total } = await getGrowthData(curParams)
        // item.rant = (((total - preTotal) / preTotal) * 100).toFixed(1)
      });
      const datas = value.sort(function (a, b) {
        return b.total - a.total;
      });
      const dataOrigons = datas[0].total;
      datas.forEach((item, index) => {
        if (item.INVENTOR === "周国富") {
          item.total = item.total + 1;
        }
        item.id = index + 1;
        item.ratio = (item.total / dataOrigons).toFixed(2) * 100;
      });
      this.inventorList = datas.slice(0, 3);
      // console.log(datas);
    },
    async initCollage() {
      const { value: collageValue } = await getchartData(this.collageParams);
      const data1 = collageValue.filter(
        (item) => item.PUBLICATION_YEAR === currentYear
      );
      data1.forEach(async (item) => {
        if (item.ORG === "华南先进光电子研究院") {
          item.total = item.application_num_total + 1;
        } else {
          item.total = item.application_num_total;
        }
        const preParams = {
          queryFilter: {
            pageBean: {
              page: 1,
              pageSize: 20,
            },
            querys: [
              {
                group: "main",
                operation: "LIKE",
                property: "F_ORG_NAME",
                relation: "AND",
                value: item.ORG,
              },
              {
                group: "main",
                operation: "BETWEEN",
                property: "F_APPLICATION_DATE",
                relation: "AND",
                value: this.preGrowth,
              },
            ],
          },
          templateId: TEMPLATEID,
        };

        const curParams = {
          queryFilter: {
            pageBean: {
              page: 1,
              pageSize: 20,
            },
            querys: [
              {
                group: "main",
                operation: "LIKE",
                property: "F_ORG_NAME",
                relation: "AND",
                value: item.ORG,
              },
              {
                group: "main",
                operation: "BETWEEN",
                property: "F_APPLICATION_DATE",
                relation: "AND",
                value: ["1986-01-01", this.date],
              },
            ],
          },
          templateId: TEMPLATEID,
        };
        Promise.all([getGrowthData(preParams), getGrowthData(curParams)]).then(
          (res) => {
            const preTotal = res[0].total;
            const total = res[1].total;
            const rant = (((total - preTotal) / preTotal) * 100).toFixed(1);
            this.$set(item, "rant", rant);
          }
        );
        // const { total: preTotal } = await getGrowthData(preParams)
        // const { total } = await getGrowthData(curParams)

        // item.rant = (((total - preTotal) / preTotal) * 100).toFixed(1)
      });
      const dataCollage = data1.sort(function (a, b) {
        return b.total - a.total;
      });
      const dataOrigon = dataCollage[0].total;
      dataCollage.forEach((item) => {
        item.ratio = (item.total / dataOrigon).toFixed(2) * 100;
      });
      this.collageList = dataCollage;
    },
    async newPatentApp() {
      const appParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_APPLICATION_DATE",
              relation: "AND",
              value: [`1986-01-01`, currentTime],
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const preAppParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_APPLICATION_DATE",
              relation: "AND",
              value: this.preGrowth,
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const newAppParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_APPLICATION_DATE",
              relation: "AND",
              value: [`${currentYear}-01-01`, currentTime],
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      // 第一段
      const res1 = await getGrowthData(appParams);
      console.log("appParams搜索条件", appParams);
      console.log("appParams返回结果", res1);
      const { total } = res1 || {};

      // 第二段
      const res2 = await getGrowthData(preAppParams);
      console.log("preAppParams搜索条件", preAppParams);
      console.log("preAppParams返回结果", res2);
      const { total: preTotal } = res2 || {};

      // 第三段
      const res3 = await getGrowthData(newAppParams);
      console.log("newAppParams搜索条件", newAppParams);
      console.log("newAppParams返回结果", res3);
      const { total: newTotal } = res3 || {};
      this.appTotal = newTotal;

      this.showApplyNegative = total - preTotal < 0;
      this.appGrowth = parseFloat(
        (((total - preTotal) / preTotal) * 100).toFixed(1)
      );
    },
    isApplyNegative(percent) {
      return this.showApplyNegative ? `-${percent}%` : `${percent}%`;
    },
    isAuthorNegative(percent) {
      return this.showAuthorNegative ? `-${percent}%` : `${percent}%`;
    },
    async newPatentAuthorize() {
      const authorParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "EQUAL",
              property: "F_LEGAL_STATUS",
              relation: "AND",
              value: "authorization",
            },
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_PUBLICATION_DATE",
              relation: "AND",
              value: [`1986-01-01`, currentTime],
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const preAuthorParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "EQUAL",
              property: "F_LEGAL_STATUS",
              relation: "AND",
              value: "authorization",
            },
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_PUBLICATION_DATE",
              relation: "AND",
              value: this.preGrowth,
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      const newAuthorParams = {
        queryFilter: {
          pageBean: {
            page: 1,
            pageSize: 20,
          },
          querys: [
            {
              group: "main",
              operation: "EQUAL",
              property: "F_LEGAL_STATUS",
              relation: "AND",
              value: "authorization",
            },
            {
              group: "main",
              operation: "BETWEEN",
              property: "F_PUBLICATION_DATE",
              relation: "AND",
              value: [`${currentYear}-01-01`, currentTime],
            },
          ],
        },
        templateId: TEMPLATEID,
      };
      // 本年度新增专利授权/件数
      const res1 = await getGrowthData(authorParams);
      console.log(
        "authorParams的搜索条件（本年度新增专利授权/件数）",
        authorParams
      );
      console.log("authorParams返回的结果（本年度新增专利授权/件数）", res1);
      const { total } = res1 || {};

      const res2 = await getGrowthData(preAuthorParams);
      console.log(
        "preAuthorParams的搜索条件（本年度新增专利授权/件数）",
        preAuthorParams
      );
      console.log("preAuthorParams返回的结果（本年度新增专利授权/件数）", res2);
      const { total: preTotal } = res2 || {};

      const res3 = await getGrowthData(newAuthorParams);
      console.log(
        "newAuthorParams的搜索条件（本年度新增专利授权/件数）",
        newAuthorParams
      );
      console.log("newAuthorParams返回的结果（本年度新增专利授权/件数）", res3);
      const { total: newTotal } = res3 || {};
      this.authorTotal = newTotal;
      this.showAuthorNegative = total - preTotal < 0;
      this.authorGrowth = parseFloat(
        (((total - preTotal) / preTotal) * 100).toFixed(1)
      );
    },
  },
};
</script>
